import React from 'react';

import { SearchFormFieldEnum } from '../../common/searchFormField.types';
import { CriteriaOperatorEnum, CriteriaTypeEnum, SearchQueryRequestType } from '../../common/types';
import { FormSelectWithSearch } from '../../components/forms/FormSelectWithSearch';
import { useSearchCandidates } from '../../features/candidates/useSearchCandidates';
import { CandidateType } from '../candidates/Candidates.types';

const mapFormValueToSearchPayload = (newValue?: string): SearchQueryRequestType => {
  return {
    criteria: newValue
      ? [
          {
            field: SearchFormFieldEnum.FirstName,
            value: newValue,
            operator: CriteriaOperatorEnum.LK,
            type: CriteriaTypeEnum.SHOULD,
          },
          {
            field: SearchFormFieldEnum.LastName,
            value: newValue,
            operator: CriteriaOperatorEnum.LK,
            type: CriteriaTypeEnum.SHOULD,
          },
        ]
      : [],
    sort: [],
    from: 0,
    max: 10000,
  };
};

const mapResponseToOptions = (results: CandidateType[]) =>
  results.map((item) => ({
    value: item.uuid,
    label: `${item.firstName} ${item.lastName}`,
  }));

export const FormCandidateSelectWithSearch: React.FC = () => {
  return (
    <FormSelectWithSearch
      name="candidateUuid"
      label="Candidate"
      search={useSearchCandidates}
      mapFormValueToPayload={mapFormValueToSearchPayload}
      mapResponseToOptions={mapResponseToOptions}
      required
    />
  );
};
